<!-- Global Notification Container (available for all routes) -->
<app-notification-container></app-notification-container>

<!-- Layout for unauthenticated users (public routes) -->
@if (isPublicRoute() || !isAuthenticated()) {
<div class="public-layout">
  <router-outlet></router-outlet>
</div>
}

<!-- Layout for authenticated users -->
@if (!isPublicRoute() && isAuthenticated()) {
<div class="authenticated-layout min-h-screen bg-gray-50">
  <!-- Global Scanner Component -->
  <app-global-scanner></app-global-scanner>

  <!-- What's New Banner -->
  <app-whats-new-banner></app-whats-new-banner>

  <!-- Top Navigation Bar -->
  <header class="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
    <div class="flex items-center justify-between px-4 h-16">
      <!-- Menu Toggle & Logo -->
      <div class="flex items-center gap-4">
        <button
          (click)="toggleMenu()"
          class="menu-toggle-btn p-2.5 rounded-xl bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 focus:outline-none focus:ring-4 focus:ring-primary-200 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95"
          [attr.aria-expanded]="isMenuOpen()"
          aria-label="Toggle navigation menu"
          title="Expandir/Retrair Menu"
          type="button"
        >
          <app-icon
            name="menu"
            color="gray"
            [size]="20"
            class="text-white transition-transform duration-300"
            [class.rotate-90]="isMenuOpen()"
          ></app-icon>
        </button>

        <div class="flex items-center gap-2">
          <div
            class="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center"
          >
            <app-icon
              name="inventory_2"
              color="gray"
              size="sm"
              class="text-white"
            ></app-icon>
          </div>
          <span class="text-xl font-bold text-gray-900">Estokai</span>
        </div>
      </div>

      <!-- Right Side Actions - Expanded for ESTOKAI_OWNER -->
      <div class="flex items-center gap-2">
        <!-- PWA Notification Center -->
        <app-notification-center></app-notification-center>

        <!-- ESTOKAI_OWNER Extended Navbar -->
        @if (isEstokaiOwner()) {
        <div
          class="flex items-center gap-2 bg-gradient-to-r from-primary-50 to-purple-50 rounded-xl px-4 py-2 border border-primary-200"
        >
          <!-- Profile Selector Component -->
          <app-profile-selector></app-profile-selector>

          <!-- Store Selector -->
          @if (canSelectStore()) {
          <div class="hidden lg:block">
            <select
              class="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 bg-white min-w-[120px]"
            >
              <option>Loja Principal</option>
              <option>Filial 1</option>
              <option>Filial 2</option>
            </select>
          </div>
          }

          <!-- Account & Logout Row -->
          <div
            class="flex items-center gap-2 ml-2 pl-2 border-l border-gray-300"
          >
            <!-- Account Info -->
            <div class="hidden xl:flex items-center gap-2 text-sm">
              <div
                class="w-7 h-7 bg-primary-100 rounded-full flex items-center justify-center"
              >
                <app-icon
                  name="account_circle"
                  color="primary"
                  [size]="16"
                ></app-icon>
              </div>
              <div class="text-left">
                <div class="text-xs font-medium text-gray-900">
                  {{ username() }}
                </div>
                <div class="text-xs text-primary-600 font-medium">
                  {{ getCurrentProfileDisplayName() }}
                </div>
              </div>
            </div>

            <!-- Logout Button -->
            <button
              (click)="logout()"
              class="flex items-center gap-1 px-3 py-1.5 text-sm text-gray-700 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors border border-gray-200 hover:border-red-200"
              title="Sair"
            >
              <app-icon name="logout" color="gray" [size]="16"></app-icon>
              <span class="hidden lg:inline">Sair</span>
            </button>
          </div>
        </div>
        } @else {
        <!-- Regular User Menu -->
        <div class="flex items-center gap-4">
          <!-- Store Selector (if applicable) -->
          @if (canSelectStore()) {
          <div class="hidden md:block">
            <select
              class="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            >
              <option>Loja Principal</option>
              <option>Filial 1</option>
              <option>Filial 2</option>
            </select>
          </div>
          }

          <!-- User Menu -->
          <div class="relative">
            <!-- User Info & Logout -->
            <div class="relative">
              <button
                #userMenuButton
                (click)="toggleUserMenu()"
                class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors"
                [attr.aria-expanded]="isUserMenuOpen()"
                aria-haspopup="true"
                type="button"
              >
                <div
                  class="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center"
                >
                  <app-icon
                    name="account_circle"
                    color="primary"
                    [size]="18"
                  ></app-icon>
                </div>

                <div class="hidden md:block text-left">
                  <div class="text-sm font-medium text-gray-900">
                    {{ username() }}
                  </div>
                  <div class="text-xs text-primary-600 font-medium">
                    {{ getCurrentProfileDisplayName() }}
                  </div>
                </div>

                <app-icon
                  name="arrow_drop_down"
                  color="gray"
                  [size]="18"
                ></app-icon>
              </button>

              <!-- User Dropdown Menu -->
              <div
                *ngIf="isUserMenuOpen()"
                class="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50"
              >
                <!-- If in view mode, show reset option -->
                <button
                  *ngIf="isViewModeActive() && isEstokaiOwner()"
                  (click)="resetToOriginalView()"
                  class="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors border-b border-gray-100"
                >
                  <app-icon name="restore" color="gray" [size]="18"></app-icon>
                  <span>Retornar ao ESTOKAI OWNER</span>
                </button>

                <!-- Logout button -->
                <button
                  (click)="logout()"
                  class="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                >
                  <app-icon name="logout" color="gray" [size]="18"></app-icon>
                  <span>Sair</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </header>

  <div class="flex">
    <!-- Sidebar Navigation -->
    <nav
      class="bg-white border-r border-gray-200 transition-all duration-300 ease-in-out"
      [class.w-48]="isMenuOpen()"
      [class.w-12]="!isMenuOpen()"
      [class.md:w-48]="isMenuOpen()"
      [class.md:w-12]="!isMenuOpen()"
    >
      <div class="p-1.5 h-full">
        <!-- Modern Navigation Menu Component -->
        <app-navigation-menu-modern
          [menuItems]="filteredMenuItems()"
          [categories]="categoriesWithItems()"
          [userRoles]="userRoles()"
          [isMenuExpanded]="isMenuOpen()"
          (itemClick)="onMenuItemClick($event)"
        ></app-navigation-menu-modern>
      </div>
    </nav>

    <!-- Main Content Area -->
    <main class="flex-1 overflow-hidden">
      <div class="h-full overflow-y-auto">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>

  <!-- PWA Components -->
  <app-pwa-install-banner></app-pwa-install-banner>
  <app-camera-capture #cameraCapture></app-camera-capture>

  <!-- Floating Share Button -->
  <div class="fixed bottom-6 left-6 z-40 md:hidden">
    <app-share-button
      variant="primary"
      text="🔗"
      title="Compartilhar página atual"
      class="rounded-full p-3 shadow-lg"
    ></app-share-button>
  </div>
</div>
}
